var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { RepairCasesService } from '~/services/domain-service/repair-cases.service';
import { RobCaseService } from '~/services/domain-service/rob-case.service.ts';
var RepairCaseDistrubute = /** @class */ (function (_super) {
    __extends(RepairCaseDistrubute, _super);
    function RepairCaseDistrubute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.distributeType = "";
        return _this;
    }
    RepairCaseDistrubute.prototype.emitSuccess = function () {
        this.$message.success('分配成功');
        this.emitClose();
    };
    RepairCaseDistrubute.prototype.emitClose = function () {
        this.distributeType = "";
    };
    Object.defineProperty(RepairCaseDistrubute.prototype, "overdueAmount", {
        get: function () {
            var sum = this.selectionList
                .map(function (v) { return v.overdueAmount; })
                .reduce(function (a, b) { return a + b; }, 0)
                .toFixed(2);
            return sum;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 首次打开弹窗执行
     */
    RepairCaseDistrubute.prototype.update = function () {
        this.distributeType = "TEL";
    };
    /**
     * 确定
     */
    RepairCaseDistrubute.prototype.submit = function () {
        var caseId = this.selectionList.map(function (v) { return v.id; });
        var paramData = {
            caseIds: caseId,
            distributeType: this.distributeType,
        };
        this.repairCasesService.confirmDistributeCase(paramData).subscribe(this.emitSuccess);
    };
    /**
     * 抢案 -- 确定
     */
    RepairCaseDistrubute.prototype.submitTwo = function () {
        var caseId = this.selectionList.map(function (v) { return v.id; });
        var paramData = {
            caseIds: caseId,
            distributeType: this.distributeType,
        };
        this.robCaseService.distributeRobCase(paramData).subscribe(this.emitSuccess);
    };
    __decorate([
        Prop()
    ], RepairCaseDistrubute.prototype, "selectionList", void 0);
    __decorate([
        Prop()
    ], RepairCaseDistrubute.prototype, "robberyCaseTrue", void 0);
    __decorate([
        Dependencies(RobCaseService)
    ], RepairCaseDistrubute.prototype, "robCaseService", void 0);
    __decorate([
        Dependencies(RepairCasesService)
    ], RepairCaseDistrubute.prototype, "repairCasesService", void 0);
    __decorate([
        Emit('success')
    ], RepairCaseDistrubute.prototype, "emitSuccess", null);
    __decorate([
        Emit('close')
    ], RepairCaseDistrubute.prototype, "emitClose", null);
    RepairCaseDistrubute = __decorate([
        Component({
            components: {},
        })
    ], RepairCaseDistrubute);
    return RepairCaseDistrubute;
}(Vue));
export default RepairCaseDistrubute;
